export interface ITenantConfig {
	LOCIZE_PROJECT_ID: string;
	LOCIZE_API_KEY: string;
	LOCIZE_SAVE_MISSING: boolean;
}

export interface ICompanyLogo {
	logo: string;
	logoPositioning: {
		defaultZoom: number;
		extendedZoom: number;
		extendedWidthRatio: number;
	};
}

export default class ConfigService {
	static config: ITenantConfig = {
		LOCIZE_API_KEY: import.meta.env.VITE_LOCIZE_API_KEY ?? 'f36b275d-747a-4a1a-9771-26c31dfdbe65',
		LOCIZE_PROJECT_ID:
			import.meta.env.VITE_LOCIZE_PROJECT_ID ?? '1411fc65-e229-4585-af21-a35561f17f5d',
		LOCIZE_SAVE_MISSING: false,
	};

	static configsUrl = import.meta.env.VITE_CONFIGS_URL ?? 'https://ontreams.com';

	static async fetchConfigForHost(
		host: string,
		isDevEnvironment: boolean = false,
	): Promise<ITenantConfig> {
		if (isDevEnvironment) {
			return Promise.resolve(ConfigService.config);
		}

		const config: ITenantConfig = {
			LOCIZE_API_KEY: import.meta.env.VITE_LOCIZE_API_KEY ?? 'f36b275d-747a-4a1a-9771-26c31dfdbe65',
			LOCIZE_PROJECT_ID:
				import.meta.env.VITE_LOCIZE_PROJECT_ID ?? '1411fc65-e229-4585-af21-a35561f17f5d',
			LOCIZE_SAVE_MISSING: true,
		};
		ConfigService.config = config;
		return Promise.resolve(config);
	}
}
